// Open positions shown on /join and /join/:slug.
// To add or change a role, edit this list. The role content below is placeholder
// text: replace it with your real requirements before publishing.
export const APPLY_EMAIL = 'hq@pidesk.in';

export const roles = [
  {
    slug: 'frontend-developer',
    title: 'Frontend Developer',
    type: 'Full-time',
    place: 'Remote / India',
    short: 'Build fast, polished interfaces with React.',
    about:
      'You will build the web interfaces our clients and their users interact with every day, from marketing sites to dashboards and exam platforms. You will work closely with designers and backend developers to ship features end to end.',
    responsibilities: [
      'Build responsive, accessible interfaces with React',
      'Turn designs into pixel-accurate, reusable components',
      'Integrate with REST APIs and real-time services',
      'Review code, fix bugs and keep performance high'
    ],
    requirements: [
      'Solid knowledge of JavaScript, HTML and CSS',
      'Hands-on experience with React',
      'Familiarity with Git and modern tooling',
      'A portfolio or projects we can look at'
    ],
    niceToHave: ['TypeScript', 'Framer Motion or other animation libraries', 'Testing experience']
  },
  {
    slug: 'backend-developer',
    title: 'Backend Developer',
    type: 'Full-time',
    place: 'Remote / India',
    short: 'Design APIs, databases and scalable services.',
    about:
      'You will design and build the services behind our products: APIs, databases, authentication and real-time features that stay reliable as usage grows.',
    responsibilities: [
      'Design and build REST APIs and background services',
      'Model data and optimise database queries',
      'Handle authentication, security and access control',
      'Deploy, monitor and improve production systems'
    ],
    requirements: [
      'Experience with Node.js or Python',
      'Working knowledge of SQL or NoSQL databases',
      'Understanding of API design and security basics',
      'Comfort with Git and cloud deployment'
    ],
    niceToHave: ['PostgreSQL or MongoDB in production', 'Docker', 'Real-time systems (WebSockets)']
  },
  {
    slug: 'ui-ux-designer',
    title: 'UI / UX Designer',
    type: 'Full-time',
    place: 'Remote / India',
    short: 'Shape product experiences from idea to pixels.',
    about:
      'You will shape how our products look and feel, from early wireframes to polished interfaces, working directly with developers so designs ship as intended.',
    responsibilities: [
      'Create wireframes, flows and high-fidelity designs',
      'Maintain a consistent design system across products',
      'Run quick user feedback sessions and iterate',
      'Hand off clear specs and assets to developers'
    ],
    requirements: [
      'Strong portfolio of web or mobile product design',
      'Proficiency in Figma',
      'Good eye for layout, typography and colour',
      'Ability to explain and defend design decisions'
    ],
    niceToHave: ['Motion and prototype experience', 'Basic HTML/CSS knowledge', 'Branding experience']
  },
  {
    slug: 'internship',
    title: 'Internship',
    type: 'Internship',
    place: 'Remote / India',
    short: 'Learn by building alongside our team on live projects.',
    about:
      'A hands-on internship where you contribute to real client and community projects, with mentoring and code reviews from the team.',
    responsibilities: [
      'Work on assigned features under a mentor',
      'Fix bugs and write small, well-tested changes',
      'Join team discussions and demos',
      'Document what you build and learn'
    ],
    requirements: [
      'Basic programming knowledge in any modern language',
      'Willingness to learn quickly and ask questions',
      'A few personal or college projects to show',
      'Availability for the internship period'
    ],
    niceToHave: ['Experience with React or Node.js', 'Open-source contributions', 'Participation in hackathons']
  }
];

export const getRole = (slug) => roles.find((r) => r.slug === slug);

export const applyLink = (roleTitle) =>
  `mailto:${APPLY_EMAIL}?subject=${encodeURIComponent(`Application: ${roleTitle}`)}&body=${encodeURIComponent(
    'Hi Pidesk team,\n\nI would like to apply for this role.\n\nName:\nPortfolio / GitHub / resume link:\n\nA few lines about me:\n'
  )}`;
